<template>
    <v-container :class="dense ? 'pa-0' : ''">
        <v-card elevation="0">
            <v-form :value="valid">
                <v-card-text :class="dense ? 'pa-0' : ''">
                    <v-row class="my-2">
                        <v-col cols="12" class="d-flex justify-center" :class="dense ? 'pa-0' : ''">
                            <v-chip v-if="label && !$mobile" outlined label :ripple="false" style="height: 40px" class="ml-3 mr-2">{{ label }}</v-chip>
                            <v-select id="currency" class="text-uppercase currency-select" v-model="select" :items="currencies" item-text="name" item-value="value" hide-details="false" :append-icon="mdiChevronDown" style="max-width: 40%" dense filled flat @change="convertCurrency()">
                                <template v-if="select === 'NEAR'" v-slot:prepend-inner>
                                    <icon-base height="25" width="25" viewBox="0 0 180 225" icon-name="near" class="d-flex align-center">
                                        <icon-near iconColor="rgba(0, 0, 0, 1)" />
                                    </icon-base>
                                </template>
                                <template v-else v-slot:prepend-inner>
                                    <span>💲</span>
                                </template>
                            </v-select>
                            <v-text-field :readonly="readonly" :rules="rules" id="price" hide-details="auto" outlined class="mx-2" style="max-width: 50%" hint="" dense v-model="priceConversion[select]" @input="convertCurrency()">
                                <template v-slot:label>
                                    {{ `Amount in ${select}` }}
                                    <span v-if="readonly" class="font-weight-medium black--text">(read only)</span>
                                </template>
                                <template v-if="select === 'NEAR'" v-slot:append>
                                    <span style="font-size: smaller">💲</span>
                                    <div style="font-size: smaller">{{ priceConversion.USD }}</div>
                                </template>
                                <template v-else-if="select === 'USD'" v-slot:append>
                                    <icon-base height="15" width="15" viewBox="0 0 180 225" icon-name="near" class="d-flex align-center">
                                        <icon-near iconColor="rgba(0, 0, 0, 1)" />
                                    </icon-base>
                                    <span style="font-size: smaller">{{ priceConversion.NEAR }}</span>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-spacer></v-spacer>
                    </v-row>
                </v-card-text>
                <v-card-actions v-if="!hideActions" class="d-flex justify-center">
                    <v-btn text @click="$emit('cancel')">cancel</v-btn>
                    <v-btn text outlined @click="buttonHandler">confirm</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-container>
</template>
<style>
.v-select__selection--comma {
    overflow: unset;
}
</style>
<script>
import IconNear from '../components/IconNear.vue';
import IconBase from '../components/IconBase.vue';
import { mdiChevronDown, mdiCurrencyUsd } from '@mdi/js';

export default {
    name: 'BnftGiftAmount',
    components: {
        IconBase,
        IconNear,
    },
    props: {
        value: Number,
        id: Object,
        hideActions: Boolean,
        dense: Boolean,
        label: String,
        defaultCurrency: String,
        readonly: Boolean,
    },
    methods: {
        async convertCurrency() {
            if (
                this.select === 'NEAR' &&
                this.listing &&
                this.listing.averageUSD
            ) {
                if (isNaN(this.priceConversion.NEAR)) return;
                this.$set(
                    this.priceConversion,
                    'USD',
                    Number.parseFloat(
                        this.priceConversion.NEAR * this.listing.averageUSD
                    ).toFixed(2)
                );
            } else if (this.select === 'USD' && this.listing) {
                if (isNaN(this.priceConversion.USD)) return;
                this.$set(
                    this.priceConversion,
                    'NEAR',
                    Number.parseFloat(
                        this.priceConversion.USD * (1 / this.listing.averageUSD)
                    ).toFixed(2)
                );
            }
            this.$emit(
                'change',
                Number(this.priceConversion.USD)
            );
        },
        async buttonHandler() {
            const self = this;
            self.progress = true;
            try {
                await this.$near.wishlist({
                    functionName: 'give_wishlist_items',
                    contractArgs: {
                        unique_item_ids: [self.id],
                    },
                    depositAmount: this.$near.utils.format.parseNearAmount(
                        this.priceConversion.NEAR
                    ),
                    loginRedirect: true,
                });
                self.progress = false;
            } catch (error) {
                self.progress = false;
                console.log(error);
            }
        },
    },
    model: {
        event: 'change',
    },
    watch: {
        rules(value) {
            $emit('rules', value);
        },
        value(value) {
            this.$set(this.priceConversion, 'USD', value);
        }
    },
    data: function () {
        return {
            mouseover: false,
            mdiChevronDown,
            mdiCurrencyUsd,
            priceConversion: {
                NEAR: 0,
                USD: this.value,
            },
            listing: null,
            select: this.defaultCurrency || 'NEAR',
            currencies: [
                { name: 'near', value: 'NEAR' },
                { name: 'usd', value: 'USD' },
            ],
            blockchain: null,
            progress: false,
            valid: undefined,
            rules: [
                (v) => !isNaN(Number(v)) || 'Must be a number.',
            ],
        };
    },
    mounted() {
        const self = this;
        self.$emit('rules', self.rules);
        (async function () {
            self.listing = await self.$backend.getLatestNearListing();
        })();
    },
};
</script>
